import {createFileRoute} from '@tanstack/react-router'
import CheckoutView from "../../../marketplace/CheckoutView.tsx";

export const Route = createFileRoute('/_app/marketplace/checkout/$game_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <CheckoutView />
}
